{
	"backLinkTitle": "Zurück zu Erklärungen verwalten"
}
